/**
* @license Apache-2.0
*
* Copyright (c) 2025 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //

var hasToPrimitiveSymbolSupport = require( '@stdlib/assert-has-to-primitive-symbol-support' ); // eslint-disable-line id-length
var Symbol = require( '@stdlib/symbol-ctor' );


// MAIN //

/**
* Symbol which specifies a method for converting an object to a primitive value.
*
* @constant
* @type {(symbol|null)}
* @default
*
* @example
* var Number = require( '@stdlib/number-ctor' );
*
* function valueOf( hint ) {
*     if ( hint === 'string' ) {
*         return 'MyObject';
*     }
*     if ( hint === 'number' ) {
*         return 42;
*     }
*     return null;
* }
*
* var obj = {};
* obj[ ToPrimitiveSymbol ] = valueOf;
*
* var str = String( obj );
* // returns 'MyObject'
*
* var num = Number( obj );
* // returns 42
*/
var ToPrimitiveSymbol = ( hasToPrimitiveSymbolSupport() ) ? Symbol.toPrimitive : null; // eslint-disable-line max-len


// EXPORTS //

module.exports = ToPrimitiveSymbol;
